import { render, staticRenderFns } from "./entrepreneurAccepted.vue?vue&type=template&id=ddc4dcca&scoped=true"
import script from "./entrepreneurAccepted.vue?vue&type=script&lang=js"
export * from "./entrepreneurAccepted.vue?vue&type=script&lang=js"
import style0 from "./entrepreneurAccepted.vue?vue&type=style&index=0&id=ddc4dcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc4dcca",
  null
  
)

export default component.exports